import { render, staticRenderFns } from "./SpendDetails.vue?vue&type=template&id=263b377c&scoped=true"
import script from "../../assets/ts/recharge/SpendDetails.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/recharge/SpendDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./SpendDetails.vue?vue&type=style&index=0&id=263b377c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b377c",
  null
  
)

export default component.exports